import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setIsLoading } from "../../../features/datatable/dataTableSlice";

import {
  getStringValues,
  createAnalysis,
  getHeaders,
} from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getUChart } from "../../../utils/computation/getUChart";
import Dropdown from "../../Dropdown";
import FunctionButtons from "../modules/FunctionButtons";
import { checkArrayLengths } from "../../../utils/functions/checkArrayLength";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "25%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

const UChartModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [firstCol, setFirstCol] = useState("");
  const [secondCol, setSecondCol] = useState("");
  const [thirdCol, setthirdCol] = useState("");
  const [error, setError] = useState(false);

  //params
  const { documentId } = useParams();

  //dispatch
  const dispatch = useDispatch();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //functions
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    closeMenu();
    setOpenModal(false);
  };

  const createGraph = async () => {
    dispatch(setIsLoading());
    // get the array value of selected columns
    const firstValue = getStringValues(data, firstCol);
    const secondValue = getColumnValues(data, secondCol);
    const thirdValue = getColumnValues(data, thirdCol);

    const XHeader = getHeaders(data, firstCol);
    const YHeader = getHeaders(data, secondCol);
    const ZHeader = getHeaders(data, thirdCol);

    const arrayData = [
      { title: XHeader[0], array: firstValue },
      { title: YHeader[0], array: secondValue },
      { title: ZHeader[0], array: thirdValue },
    ];
    const res = checkArrayLengths(arrayData);

    const haveSameLength = res.isSuccess;
    haveSameLength ? setError(false) : setError(res.message);
    haveSameLength && closeMenu();
    if (firstValue.length > 0 && secondValue.length > 0 && haveSameLength) {
      let res = await getUChart({
        arr1: firstValue,
        arr2: secondValue,
        arr3: thirdValue,
      });

      const graphs = {
        ...res,
        column: firstCol + ", " + secondCol + ", " + thirdCol,
        title,
      };

      try {
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          graphs
        );
        graphs.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }
    } else {
    }
    dispatch(setIsLoading());
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> C-Chart</h1>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} p={1}>
            <h3> Data Range</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select First Column
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown
                value={firstCol}
                onChange={(e) => setFirstCol(e.target.value)}
              />
            </FormControl>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select Second Column
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown
                value={secondCol}
                onChange={(e) => setSecondCol(e.target.value)}
              />
            </FormControl>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select Third Column
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown
                value={thirdCol}
                onChange={(e) => setthirdCol(e.target.value)}
              />
            </FormControl>
          </Grid>
        </Grid>
        <FunctionButtons
          handleCloseModal={handleCloseModal}
          error={error}
          computeTTest={createGraph}
        />
      </Box>
    </Modal>
  );
};

export default UChartModal;
